import { TYPES } from "../actions";

const initialState = {
    agents: []
};

export const agentReducer = (state = initialState, action) => {
    switch (action.type) {
        case TYPES.ACTION_GET_AGENTS_SUCCESS:
            return {
                ...state,
                agents: action.payload.data
            };
        case TYPES.ACTION_GET_AGENTS_FAIL:
            return {
                ...state,
                agents: []
            };
        default:
            return state;
    }
}; 